<template>
  <div>
    <button class="flex-y-center gap-2 group">
      <span class="text-xl leading-130 font-semibold text-dark">
        {{ $t("change_email") }}
      </span>
    </button>
    <FGroup :label="$t('enter_password')" class="my-8">
      <FInput
        :placeholder="$t('enter_password')"
        :type="isPassword ? 'password' : 'text'"
        v-model="form.values.password"
        :error="form.$v.value.password?.$error"
        @keypress.enter.prevent="onEnter"
      >
        <template #suffix>
          <SEyeToggle
            class="translate-y-0.5"
            :type-password="!isPassword"
            @click="isPassword = !isPassword"
            hover-color="#333"
          />
        </template>
      </FInput>
    </FGroup>
    <SButton
      class="w-full"
      :text="$t('next')"
      @click="submit"
      :loading="loading"
      v-bind="{ disabled }"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import SButton from "@/components/Common/CButton.vue";
import { useCustomToast } from "@/composables/useCustomToast";
import { useI18n } from "vue-i18n";
import { useAuthStore } from "@/modules/Auth/stores";
import FInput from "@/components/Form/Input/FInput.vue";
import FGroup from "@/components/Form/FGroup.vue";
import ApiService from "@/services/ApiService";
import { useForm } from "@/composables/useForm";
import { required } from "@vuelidate/validators";
import SEyeToggle from "@/components/Form/Input/CEyeToggle.vue";

const form = useForm(
  {
    password: "",
  },
  {
    password: { required },
  },
);

const emit = defineEmits(["submit", "back", "on-block"]);

const { showToast } = useCustomToast();
const store = useAuthStore();
const { t } = useI18n();

const disabled = ref(true);
const loading = ref(false);
const isPassword = ref(true);

async function submit() {
  form.$v.value.$touch();

  if (!form.$v.value.password.$invalid) {
    loading.value = true;

    ApiService.post(`/user/change/password/`, {
      password: form.values.password,
    })
      .then(() => {
        emit("submit");
      })
      .catch((err: any) => {
        if (err?.response?.status === 429) {
          emit("on-block");
          store.blockedTime = +err?.response?.headers["retry-after"];
        } else {
          showToast(
            err?.response?.data?.non_field_errors?.[0]
              ? t("check_password_password")
              : t("some_error"),
            "error",
          );
        }
        loading.value = false;
      })
      .finally(() => (loading.value = false));
  }
}

watch(
  () => form.$v.value.password.$invalid,
  () => {
    disabled.value = form.$v.value.password.$invalid;
  },
  { immediate: true },
);

function onEnter() {
  submit();
}
</script>
